// @ts-nocheck
// TypeScript is ignoring this file. If you are editing this file you must fix the type issues.

import React, { useState, useEffect, useContext } from 'react';

import { useTranslation } from 'react-i18next';
import Heading from '../../Heading';
import RadioButton from '../../RadioButton';
import Button from '../../Button';

import { MFA_STEPS_MAP, RESEND_VERIFICATION_SCREEN_DATA, BACK_BUTTON_STYLE, MFA_TEXTS } from '../helpers/constants';

import { ILoginRadioButtons } from '../../../types';
import Icon from '../../Icon';
import { MfaContext } from '../index';
import { useMfaMutation } from '../../../hooks/mutations/useMfaMutation';
import { MfaType } from '../types';
import { LiliLogoNew } from '../../../assets/svg';

const ResendVerification = () => {
  const [currentButton, setCurrentButton] = useState<ILoginRadioButtons | undefined>();
  const [radioButtons, setRadioButtons] = useState(new Map());
  const [radioBtnsFromResponse, setRadioBtnsFromResponse] = useState<any>(null);

  const { setActiveStep, setLocalMfaType } = useContext(MfaContext)!;
  const { mutateAsync: requestOtp } = useMfaMutation();
  const { reqOtpPayload } = useContext(MfaContext)!;

  const { mfaActionData, mfaType } = reqOtpPayload;

  const { HEADING, TEXT } = RESEND_VERIFICATION_SCREEN_DATA;

  useEffect(() => {
    const newMap = reqOtpPayload.mfaActionData.mfaTypesOptions.map((item: string, index: number) => ({
      title: item === MfaType.SMS ? MFA_TEXTS.TITLE_SMS : item === MfaType.VOICE ? MFA_TEXTS.TITLE_VOICE : null,
      id: item === MfaType.SMS ? 'message' : item === MfaType.VOICE ? 'call' : null,
      TYPE: item === MfaType.SMS ? MfaType.SMS : item === MfaType.VOICE ? MfaType.VOICE : null,
      BUTTON_TITLE:
        item === MfaType.SMS
          ? MFA_TEXTS.BUTTON_TITLE_SMS
          : item === MfaType.VOICE
            ? MFA_TEXTS.BUTTON_TITLE_VOICE
            : null,
      checked: index === 0,
    }));

    const newCurrentButton = newMap.find(({ checked }: any) => !!checked);
    const buttons = new Map();

    newMap.forEach((radioButton: { id: any }) => {
      buttons.set(radioButton.id, radioButton);
    });

    setRadioBtnsFromResponse(newMap);

    setCurrentButton(newCurrentButton);
    setRadioButtons(buttons);
  }, []);

  useEffect(() => {
    setLocalMfaType(currentButton?.TYPE);
  }, [currentButton]);

  const handleResendCode = () => {
    requestOtp({ payload: { ...mfaActionData, mfaType } })
      .then(() => {
        // Handel success
      })
      .catch();
  };

  const handleButtonClick = (id: string) => {
    setLocalMfaType(radioButtons.get(id).TYPE);
    setCurrentButton(radioButtons.get(id));
  };

  const handleOnClick = () => {
    setActiveStep(MFA_STEPS_MAP.INTRO);
    handleResendCode();
  };

  const { t } = useTranslation();

  return (
    <div className={BACK_BUTTON_STYLE.CONTAINER.CLASS_NAME}>
      <div className='top-[calc(32%-348px/2-82px)] left-[calc(50%-410px/2)] bg-bw00 absolute m-auto rounded-md p-8 radioNewStyles'>
        <Icon src={LiliLogoNew} className='mb-6' />
        <Heading title={t(HEADING.TITLE)} className={HEADING.CLASS_NAME} />
        <Heading title={t(TEXT.TITLE)} className={TEXT.CLASS_NAME} />
        <form className='mt-4'>
          <fieldset>
            {radioBtnsFromResponse &&
              radioBtnsFromResponse.length &&
              radioBtnsFromResponse.map((item: any) => (
                <RadioButton
                  id={item.id}
                  key={item.id}
                  title={t(item.title)}
                  checked={item.checked}
                  onClick={handleButtonClick}
                />
              ))}
          </fieldset>
        </form>
        <Button
          id='resendVerification'
          onClick={handleOnClick}
          title={t(currentButton?.BUTTON_TITLE ?? '')}
          className={BACK_BUTTON_STYLE.CTA_BUTTON}
        />
      </div>
    </div>
  );
};

export default ResendVerification;
